import React from 'react';
import { useConfigService, ExperienceContext } from '@thd-nucleus/experience-context';

export const IFrameManager = ({ children = null }) => {
  const maaQueryParams = useConfigService('maaqueryparams');
  let iframeSrc = import.meta.env.MAA_IFRAME_URL;
  if (maaQueryParams) {
    iframeSrc += maaQueryParams;
  }
  return (
    <>
      {children}
      <iframe
        title="Magic Apron Assistant"
        className="sui-flex-grow sui-border-none sui-min-h-0"
        src={iframeSrc}
      />
    </>
  );
};